/** Query key for the member's own part in the Neighbor spotlight. */
export const spotlightKeys = { mine: ['spotlight', 'mine'] as const };
